//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PaginationModal from "./PaginationModal";

export default {
  components: {
    PaginationModal
  },
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      modalIsOpen: false,
    }
  },
  computed: {
    getPaginationContent() {
      if (this.totalPages < 8) {
        return new Array(this.totalPages).fill(1).map((elem, i) => elem = i + 1)
      } else if (this.currentPage < 5) {
        return [1, 2, 3, 4, 5, '...', this.totalPages]
      } else if (this.currentPage > this.totalPages - 4) {
        return [1, '...', this.totalPages - 4, this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages]
      } else {
        return [1, '...', this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalPages]
      }
    }
  },
  methods: {
    getCurrentUrl(page) {
      // if (page === 1) {
      //   const query = {...this.$route.query}
      //   // if (query.pageNum) {
      //   //   delete query.pageNum
      //   // }
      //   return {
      //     path: this.$route.path,
      //     query
      //   }
      // }
      return {
        path: this.$route.path,
        query: {
          ...this.$route.query,
          pageNum: page
        }
      }
    }
  }
}
